import { Seconds } from "@/models/shared";

export const currentTimeInSeconds = (): Seconds => {
  return Math.floor(Date.now() / 1000);
};
